import DietaryBalancePreferenceView from "./DietaryBalancePreferenceView"
export default DietaryBalancePreferenceView
